module.exports = __webpack_public_path__ + "img/省级数据同步共享系统.3bdf8718.jpg";